import {useCallback, useEffect, useState} from 'react';
import {DoughnutChart, RightDropdown} from '../../../components';
import {Language} from '../../../context/LanguageContext';
import '../../../assets/styles/atd.scss';
import axios from 'axios';
import {APIURL} from '../../../consts';
import Cookies from 'js-cookie';
import {Location} from '../../../assets';
export default function ATD({
  zoomer,
  projectCode,
  pkCode,
  negeriCode,
  wilayahCode,
  mapRef,
  setPkCode,
  setNegeriCode,
  setProjectCode,
  setMarkerClick,
}) {
  const [payload, setPayload] = useState({
    tahun: {
      label: '',
      value: '',
    },
    jenisTanaman: 'sawit',
  });
  const {newObj, language} = Language();
  const [data, setData] = useState({
    ph: null,
    npk: null,
  });
  const [years, setYears] = useState([]);
  const [title, setTitle] = useState('');
  const handleZoomLevel = useCallback(
    (zoom) => {
      if (zoom >= 14) {
        return {level: 'projek', kod: projectCode ? projectCode : ''};
      } else if (zoom >= 12) {
        return {level: 'pk', kod: pkCode ? pkCode : ''};
      } else if (zoom >= 10) {
        return {level: 'negeri', kod: negeriCode ? negeriCode : ''};
      } else if (zoom >= 8) {
        return {
          level: 'wilayah',
          kod: wilayahCode ? wilayahCode : '',
        };
      } else {
        return {level: 'all', kod: 'all'};
      }
    },
    [projectCode, pkCode, negeriCode, wilayahCode]
  );
  const handleTitle = (zoom, item) => {
    if (zoom >= 14) {
      return item.nama;
    } else if (zoom >= 12) {
      return item.nama;
    } else if (zoom >= 10) {
      return item.name + ' ' + item.kod;
    } else if (zoom >= 8) {
      return item.kod;
    } else {
      return 'National';
    }
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    responsiveAnimationDuration: 0,
    aspectRatio: 1,
    width: '100%',
    plugins: {
      legend: {
        display: false, // set this to false to hide the legend
      },
    },
  };
  const getPh = useCallback(
    async (payload) => {
      try {
        const response = await axios.post(APIURL.atd_ph_get_data, payload, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${Cookies.get('token')}`,
          },
        });
        setData((prev) => ({...prev, ph: response.data.data}));
        // setYears(
        //   response.data.years.map((item) => ({label: item, value: item}))
        // );
      } catch (error) {}
    },
    [mapRef]
  );

  const getNpk = useCallback(
    async (payload) => {
      try {
        const response = await axios.post(APIURL.atd_npk_get_data, payload, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${Cookies.get('token')}`,
          },
        });
        setTitle(handleTitle(zoomer, response.data.payload));
        setData((prev) => ({...prev, npk: response.data.data}));
        setYears(
          response.data.years.map((item) => ({label: item, value: item}))
        );
      } catch (error) {}
    },
    [zoomer, mapRef]
  );

  const handleGetData = async (payload) => {
    const level = handleZoomLevel(zoomer);
    let obj = {
      tahun: payload.tahun.value,
      jenisTanaman: payload.jenisTanaman,
      latitude_x: mapRef.current.getBounds()._southWest.lat,
      longitude_x: mapRef.current.getBounds()._southWest.lng,
      latitude_y: mapRef.current.getBounds()._northEast.lat,
      longitude_y: mapRef.current.getBounds()._northEast.lng,
      center_lat: mapRef.current.getBounds().getCenter().lat,
      center_long: mapRef.current.getBounds().getCenter().lng,
      flag: 'drag',
      status: 'publish',
      ...level,
      // level: 'all',
      // kod: '',
    };
    await getPh(obj);
    await getNpk(obj);
  };

  const handleUIList = (item) => {
    return (
      <>
        <div className='atd_item_content'>
          <div className='atd_content_item bg_red'>
            <p className='label'>Rendah</p>
            <p className='value'>{item.low}</p>
          </div>
          <div className='atd_content_item bg_green'>
            <p className='label'>Normal</p>
            <p className='value'>{item.normal}</p>
          </div>
          <div className='atd_content_item bg_grey'>
            <p className='label'>Blok Agronomi</p>
            <p className='value'>{item.blokAgronomi}</p>
          </div>
        </div>
      </>
    );
  };

  const handleOnClick = (zoom, item) => {
    if (zoom >= 8 && zoom < 10) {
      setNegeriCode(item.code);
    } else if (zoom >= 10 && zoom < 12) {
      setPkCode(item.code);
    } else if (zoom >= 12) {
      setProjectCode(item.code);
      setMarkerClick(true);
    }
    mapRef.current.flyTo(
      [item.latitude, item.longitude],
      mapRef.current.getZoom() + 2
    );
  };

  useEffect(() => {
    handleGetData(payload);
  }, [zoomer, payload.jenisTanaman, payload.tahun]);

  return (
    <div className='atd_ctr'>
      <div className='atd_data_ctr'>
        <div className='atd_filter'>
          <div className='atd_toggle'>
            <div
              className={`atd_toggle_item ${
                payload.jenisTanaman === 'sawit' ? 'active' : ''
              }`}
              onClick={() =>
                setPayload((prev) => ({...prev, jenisTanaman: 'sawit'}))
              }
            >
              {newObj.SawitWord[language]}
            </div>
            <div
              className={`atd_toggle_item  ${
                payload.jenisTanaman === 'getah' ? 'active' : ''
              }`}
              onClick={() =>
                setPayload((prev) => ({...prev, jenisTanaman: 'getah'}))
              }
            >
              {newObj.GetahWord[language]}
            </div>
          </div>
          <div className='atd_year'>
            <RightDropdown
              selectedMenu={payload.tahun}
              onClick={(item) => {
                setPayload((prev) => ({...prev, tahun: item}));
              }}
              menu_list={years || []}
            />
          </div>
        </div>
        <div className='atd_doughnut_ctr'>
          <p className='atd_doughnut_text'>PARAS pH ({title})</p>
          <div className='doughnut_chart'>
            <div className='doughnut_wrapper'>
              <DoughnutChart
                data={{
                  labels: ['Normal', 'Rendah'],
                  datasets: [
                    {
                      label: 'pH',
                      data: [data.ph?.normal, data.ph?.low],
                      backgroundColor: [
                        data.ph?.normalColor,
                        data.ph?.lowColor,
                      ],
                      hoverBackgroundColor: [
                        data.ph?.normalColor,
                        data.ph?.lowColor,
                      ],
                      borderColor: [data.ph?.normalColor, data.ph?.lowColor],
                      borderWidth: 1,
                    },
                  ],
                }}
                options={options}
              />
            </div>
            <div className='indicator'>
              <div className='indicator_item'>
                <div
                  className='indicator_color'
                  style={{backgroundColor: data.ph?.normalColor}}
                />
                <div className='indicator_content'>
                  <p className='indicator_text'>
                    {newObj.NormalWord[language]}
                  </p>
                  <p className='indicator_value'>{data.ph?.normal}</p>
                </div>
              </div>
              <div className='indicator_item'>
                <div
                  className='indicator_color'
                  style={{backgroundColor: data.ph?.lowColor}}
                />
                <div className='indicator_content'>
                  <p className='indicator_text'>{newObj.LowWord[language]}</p>
                  <p className='indicator_value'>{data.ph?.low}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='atd_npk_table_ctr'>
          <table className='table'>
            <thead>
              <tr>
                <th style={{color: '#fff'}}>NPK</th>
                {data.npk?.Status.map((item, index) => (
                  <th key={`npk_status_${index}`}>
                    <div
                      className='atd_th_wrapper'
                      style={{
                        backgroundColor: item.color,
                      }}
                    >
                      {item.name}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.npk?.Nutrien.map((item, index) => (
                <tr key={`npk_nutrien_${index}`}>
                  <td>
                    <div
                      className='atd_td_wrapper'
                      style={{
                        backgroundColor: item.color,
                      }}
                    >
                      {item.name}
                    </div>
                  </td>
                  {item.data.map((parameter, i) => (
                    <td
                      style={{
                        color: data.npk?.Status[i].color,
                      }}
                    >
                      {parameter}%
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className='atd_list_ctr'>
        {data.ph?.list?.length &&
          data.ph?.list?.map((item, index) => (
            <div
              className='atd_list_item'
              onClick={() => handleOnClick(zoomer, item)}
              key={`atd_list_item_${index}`}
            >
              <div className='atd_item_head'>
                <img className='atd_head_img' src={Location} alt='' />
                <p className='atd_head_title'>
                  {item.name} {zoomer < 8 ? '' : item.code}
                </p>
              </div>
              {handleUIList(item)}
            </div>
          ))}
      </div>
    </div>
  );
}
